import config, { template } from '../../../constants/Configs'
import { LanguageService } from '../../LanguageService'
import { Browser } from '../Browser'
import SportRoutingHelper from './SportRoutingHelper'
import Utils from '../../Utils'
import { CustomisationHelper } from '../CustomisationHelper'
import DeviceTypeEnum from '../../../constants/DeviceTypeEnum'
import store from '../../..'
import { LocalStorageService } from '../../LocalStorageService'
import SiteEvent from '../../events/SiteEvent'
import { COLOR_MODE_KEY, ColorModeSportNameEnum } from '../../../constants/Enums/UiEnum'
import SportEventType from './enums/SportEventType'
import SportHelper from './SportHelper'

/**
 * @namespace SportIntegration 
 */

const DeviceTypes = { Desktop: 'd', Mobile: 'm' };

export const SportViewTypeEnum = {
    Standard: 1,
    African: 2,
    Latin: 3,
    Asian: 4,
    Modern: 5,
    SimpleEast: 6
    // Paper: 5,

}

export const SportIntegrationTypeEnum = {
    Iframe: 1,
    Native: 2,
}

const SportView = {
    [SportViewTypeEnum.Standard]: "europeanView",
    [SportViewTypeEnum.African]: "africanView",
    [SportViewTypeEnum.Latin]: "LatinoView",
    // [SportViewTypeEnum.Paper]: "paperView",
    [SportViewTypeEnum.Asian]: "AsianView",
    [SportViewTypeEnum.Modern]: "ModernView",
    [SportViewTypeEnum.SimpleEast]: "SimpleEast",
}

export const SportIntegration = {

    launchMobileApp: function (containerId, page, targetId, token, callbacks, launchUrl, callback) {
        const type = SportIntegration.retrieveViewType();
        switch (type) {
            case SportViewTypeEnum.Modern:
                SportIntegration.launchDesktopApp(page, targetId, token, callbacks, launchUrl, callback);
                break;
            default:
                SportIntegration.launchStandardMobileApp(containerId, page, targetId, token, callbacks, launchUrl, callback);
                break;
        }
    },

    launchDesktopApp(page, targetId, token, events, launchUrl, callback) {
        const type = this.retrieveViewType();
        const sportViewType = SportView[type];
        switch (type) {
            case SportViewTypeEnum.Asian:
            case SportViewTypeEnum.Latin:
            case SportViewTypeEnum.Modern:
                //case SportViewTypeEnum.SimpleEast:
                SportIntegration.launchSpecialView(sportViewType, page, targetId, token, events, launchUrl, callback);
                break;
            default:
                SportIntegration.launchStandardDesktopApp(sportViewType, page, targetId, token, events, launchUrl, callback);
                break;
        }
    },

    /** Launch sportas desktop version*/
    launchStandardDesktopApp(sportViewType, page, targetId, token, events, launchUrl, callback) {
        // document.getElementById("sport_div_iframe").innerHTML = ''
        const language = LanguageService.getSelectedLanguage()
        const domain = Browser.getDomain()
        const domainforParent = Browser.getDomain(true, false)
        const { sportSettings, partnerId, userSystemRID } = store.getState().settings
        const { enableSportFixedScroll, enableSiteStylesForSport } = sportSettings
        const isDefault = Utils.isDefaultPartner(partnerId)

        const isNewRoutingModeEnabled = config?.SPORT_NEW_ROUTING?.indexOf(partnerId) >= 0 ? true : false;
        const isNewRoutingEnabledForAllPartners = config?.SPORT_NEW_ROUTING_ENABLED;

        const colorMode = CustomisationHelper.getSelectedColorModeName()
        const betslipId = SportIntegration.getBetsliptId();

        var _sp = _sp || [];
        _sp.push(['token', token ? token : '-'])
        _sp.push(['language', language])
        _sp.push(['server', launchUrl || `//sport.${domain}/`])
        _sp.push(['clearSiteStyles', enableSiteStylesForSport]);
        _sp.push(['login', 'SportLogin']);
        _sp.push(['registration', 'SportRegistration']);
        _sp.push(['zIndex', {
            closed: 950,
            opened: 998,
            fullOpened: 998
        }]);

        if (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) {
            _sp.push(['initialRoute', SportRoutingHelper.generateRouteObject(page, targetId)]);
            _sp.push(['getSportAppRoute', callback]);
            _sp.push(['pushStateDisabled', true]);
            //Temp delete when sport will fix routing issue
            //window.addEventListener("message", callback);
        } else {
            if (targetId) {
                if (this.isEventId(page)) {
                    _sp.push(['eventId', targetId]);
                } else {
                    _sp.push(['champId', targetId]);
                }
            }
            events && events.onNavigateCallback && _sp.push(['onNavigateCallback', events.onNavigateCallback]);
            _sp.push(['currentPage', page || 'Home']);
        }
        _sp.push(['device', DeviceTypes.Desktop]);
        _sp.push(['timeZone', Utils.getTimeZone()]);
        _sp.push(['fixedHeight', enableSportFixedScroll]);
        _sp.push(['disableCustomScroll', true]);
        _sp.push(['oddsFormat', '0']);
        _sp.push(['parent', [domainforParent]]);
        _sp.push(['eventsHandler', (e) => {
            if (e?.sender === 'sportdigi' && e?.eventType === 'successBet') {
                SiteEvent.dispatch({
                    type: e?.eventType,
                    category: 'sport',
                })
            }
        }
        ]);

        betslipId && _sp.push(['betslipBookNumber', betslipId]);
        _sp.push(['betslipCopyLinkUrl', `https://${domain}/${language}/sport/betslip-id/{betslipBookNumber}`]);
        sportViewType && _sp.push(['sportsBookView', sportViewType]);

        if (enableSiteStylesForSport) {
            const customCssUrl = encodeURI(`//${isDefault ? `${config.DEFAULT_SITE_URL}/templates/${template}` : domain}/css/variables.css?${Math.floor(new Date().getTime())}`)
            _sp.push(['customCssUrl', encodeURIComponent(customCssUrl)])
        } else if (colorMode) {
            _sp.push(['projectTheme', ColorModeSportNameEnum[colorMode]])
            _sp.push(['theme', colorMode])
        }

        if (userSystemRID) {
            _sp.push(['sportPartner', userSystemRID]);
        }
        events && events.balanceChangeCallback && _sp.push(['balanceChangeCallback', events.balanceChangeCallback])
        //events && events.onNavigateCallback && _sp.push(['onNavigateCallback', events.onNavigateCallback])
        _sp.push(['onContentLoaded', 'SportOnLoad'])
        window.SportFrame && window.SportFrame.frame(_sp)
    },

    /** Launch sport's Asian and Latin desktop versions */

    async launchSpecialView(viewType, page, targetId, token, events, launchUrl, callback) {

        const containerId = 'sport_div_iframe';
        const language = LanguageService.getSelectedLanguage();
        const domain = Browser.getDomain();
        const { sportSettings, partnerId, userSystemRID } = store.getState().settings;
        const { enableSiteStylesForSport } = sportSettings;
        const colorMode = CustomisationHelper.getSelectedColorModeName();
        const domainforParent = Browser.getDomain(true, false);
        const isNewRoutingModeEnabled = config?.SPORT_NEW_ROUTING?.indexOf(partnerId) >= 0 /*&& viewType != SportView[SportViewTypeEnum.Modern]*/ ? true : false;
        const isNewRoutingEnabledForAllPartners = config?.SPORT_NEW_ROUTING_ENABLED;

        const isNewURLMechanism = SportHelper.isNewUrlMechanismEnabled();


        const betslipId = SportIntegration.getBetsliptId();

        var params = {
            /* Required parameters */
            // {String} The sport URL provided by Digitain.
            server: launchUrl ? launchUrl : `//sport.${domain}/`,
            // {String} DOM element Id where application will be rendered.
            containerId,
            /* Optional parameters */
            // {String} User authorization token or '-' for unauthorized users.
            token: token ? token : '-',
            // {String} The default language ISO code.
            defaultLanguage: language,
            //externalCSSvariables: cssVariables,
            // {Number} Custom UTC Time Zone. Property is optional.
            timeZone: Utils.getTimeZone(),
            // {Function} Login popup/page opening trigger.
            // loginTrigger: function () {
            //     window.SportLogin && window.SportLogin()
            // },
            parent: [domainforParent],

            // {Boolean} Disables hash router to prevent main URL from changing on routes
            // navigation.
            // * useful in case of integrating into existing SPA.
            hashRouterDisabled: false,
            /**
            * If the parameter is set to true, all external links will be opened inside of
            * iframe in application popup. The links of the stats must be in https, if the
            * parameter is set to true.
            */
            //externalLinksOpenInside: true,
            /**
            * Array of odds format in the dropdown to be shown. Possible values: 0- decimal,
            * 1 - Fractional; 2 - American; 3 - Hong Kong; 4 - Malay; 5 – Indo. If the value of
            * the oddsformatList is not set, or an empty array is received, all the odd formats
            * will be shown.
            */
            //oddsFormatList: [0, 1, 2],
            //oddsFormat: 2
            zIndex: {
                closed: 950,
                opened: 998,
                fullOpened: 998
            }
        }

        if (betslipId) {
            params.betslipBookNumber = betslipId;
        }

        params.betslipCopyLinkUrl = `https://${domain}/${language}/sport/betslip-id/{betslipBookNumber}`;

        if (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) {
            params.initialRoute = SportRoutingHelper.generateRouteObject(page, targetId, isNewURLMechanism);
        } else if (events && events.onNavigateCallback) {
            params['onNavigateCallback'] = events.onNavigateCallback;
        }




        if (viewType === SportView[SportViewTypeEnum.Latin]) {
            params.urlStructureType = 2;
            params.sportMainPath = `https://${domain}/${language}/sport`;
            params.login = function () {
                window.SportLogin && window.SportLogin();
            }
        } else {
            params.loginTrigger = function () {
                window.SportLogin && window.SportLogin();
            }
        }

        if (enableSiteStylesForSport) {
            const cssVariables = CustomisationHelper.getCustomCssVars();
            params.externalCSSvariables = cssVariables;
        } else if (colorMode) {
            params.theme = colorMode;
            params.projectTheme = ColorModeSportNameEnum[colorMode];
        }

        if (events && events.balanceChangeCallback) {
            params['balanceChangeCallback'] = events.balanceChangeCallback;
        }

        if (userSystemRID) {
            params.sportPartner = userSystemRID;
        }

        const iframeParams = {};
        window[viewType] = await window.Bootstrapper?.bootIframe(params, { name: viewType }, iframeParams);

        if (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) {
            window[viewType] && window[viewType].addEventListener('sportAppEventDispatch', callback);
            window[viewType] && window[viewType].Betslip?.addEventListener('sportAppEventDispatch', callback);
        } else {
            //remove after new mapping implementation
            if (targetId && this.isEventId(page) && targetId !== "page") {
                window[viewType].navigateTo(`/eventDetails/${targetId}`);
            } else {
                this.openPage(page);
            }
        }
        if (events && events.balanceChangeCallback) {
            window[viewType].addEventListener("updateUserBalance", (e) => {
                events.balanceChangeCallback(e.data);
            });
        }
    },


    isEventId(page) {
        if (page === 'Upcoming') {
            return false;
        }
        return true;
    },

    isResponsiveView() {
        const viewType = SportIntegration.retrieveViewType();
        switch (viewType) {
            case SportViewTypeEnum.Modern:
                return true;
            default:
                return false;
        }
    },
    retrieveView() {
        const viewType = SportIntegration.retrieveViewType();
        return SportView[viewType];
    },
    retrieveViewType() {
        const LAST_SELECTED_SPORTS_VIEW = "sports_view";
        //Configured default view type
        const { sportViewType } = store.getState().settings.sportSettings;
        //If view type provided via url launch sport by provided view typ
        let viewType = new URLSearchParams(window.location.search).get("view");
        viewType = viewType && viewType.toLowerCase();
        //Store selected viewType on local storage
        if (viewType) {
            LocalStorageService.set(LAST_SELECTED_SPORTS_VIEW, viewType);
        }
        //If view type is not provided via URL, try to get it from local storage
        else {
            const sportsView = LocalStorageService.get(LAST_SELECTED_SPORTS_VIEW);
            viewType = sportsView ? sportsView : null;
        }
        switch (viewType) {
            case 'standard':
                return SportViewTypeEnum.Standard;
            case 'african':
                return SportViewTypeEnum.African;
            case 'latin':
                return SportViewTypeEnum.Latin;
            // case 'paper':
            //     return SportViewTypeEnum.Paper
            case 'asian':
                return SportViewTypeEnum.Asian;
            case 'modern':
                return SportViewTypeEnum.Modern;
            case 'simpleeast':
                return SportViewTypeEnum.SimpleEast;
            default:
                return sportViewType;
        }
    },
    getBetsliptId() {
        let betslipId;
        if (window?.location?.pathname?.includes('betslip-id')) {
            betslipId = window?.location?.pathname?.split('/betslip-id/')[1];
            betslipId = betslipId?.includes('/') ? betslipId.replace('/', '') : betslipId;
        } else {
            betslipId = Browser.getURLParamValue('betslip-id')
        }
        return betslipId;
    },
    openPage(page, deviceType = DeviceTypeEnum.Desktop) {
        try {
            if (deviceType === DeviceTypeEnum.Desktop) {

                //sport specefic view type case
                const viewType = this.retrieveViewType();
                const sportViewType = SportView[viewType];
                if (!page) {
                    page = `/`;
                } else if (!(page.startsWith('/'))) {
                    page = `/${page}`;
                }
                //Shame code ))))
                if (viewType === SportViewTypeEnum.Latin) {
                    if (page == `/BetsHistory` || page === "/BetsHistory/") {
                        page = `/BetHistory`;
                    }
                    // more shame code
                    if (page === "/Live/page" || page === "/Live/page/") {
                        page = '/live'
                    }
                    if (page === '/') {
                        page = '/pre-match';
                    }
                    window.SportFrame && window.SportFrame.openPage && window.SportFrame.openPage(page || '/');
                } else {
                    window.SportFrame && window.SportFrame.openPage && window.SportFrame.openPage(page?.substring(1) || 'Home');
                }
                window[sportViewType] && window[sportViewType].navigateTo && window[sportViewType].navigateTo(page);


            } else {
                page = SportIntegration.getMobilePageRoute(page, true);
                window.sportMobileApp && window.sportMobileApp.navigateTo && window.sportMobileApp.navigateTo(page);
            }
        } catch (e) {

        }
    },

    getMobilePageRoute: (page, isOpenPage, targetId) => {
        const { partnerId } = store.getState().settings;
        const isNewRoutingModeEnabled = config?.SPORT_NEW_ROUTING?.indexOf(partnerId) >= 0 ? true : false;
        const isNewRoutingEnabledForAllPartners = config?.SPORT_NEW_ROUTING_ENABLED;
        if (!page) {
            return '/';
        }
        if (page.startsWith(`/UpcomingDetails`)) {
            page = page.replace('/UpcomingDetails', '/events');
        }
        if (page.includes(`/popup`)) {
            page = page.substr(0, page.indexOf('/popup'));
        }

        switch (page) {
            case '/Overview':
            case '/Overview/':
                page = '/Live/page'
                break;
            case '/BetsHistory':
            case '/BetsHistory/': //Sorry :D
                // if (isOpenPage) {
                page = (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) ? '/bet-history' : { search: 'popup=MyBets' };
                break;
            default:
                page = page.startsWith('/') ? page : `/${page}`;
        }
        return page;
    },


    // TODO delete later (shame code)
    getInitialRouting: (page) => {
        if (page?.search === 'popup=MyBets' || page === "/BetHistory") {
            return { path: 'bet-history' }
        }
    },

    launchStandardMobileApp: async function (containerId, page, targetId, token, callbacks, launchUrl, callback) {

        const { sportSettings, partnerId, userSystemRID } = store.getState().settings;
        const enableSiteStylesForSport = sportSettings.enableSiteStylesForSport;
        let isDivIntegration = SportIntegrationTypeEnum.Native == sportSettings.sportIntegrationType;
        const language = LanguageService.getSelectedLanguage();
        const domain = Browser.getDomain();
        const domainforParent = Browser.getDomain(true, false);
        const isNewRoutingModeEnabled = config?.SPORT_NEW_ROUTING?.indexOf(partnerId) >= 0 ? true : false;
        const isNewRoutingEnabledForAllPartners = config?.SPORT_NEW_ROUTING_ENABLED;
        const colorMode = CustomisationHelper.getSelectedColorModeName();
        page = SportIntegration.getMobilePageRoute(page, false, targetId);

        const betslipId = SportIntegration.getBetsliptId();
        const viewType = SportIntegration.retrieveViewType();
        const isNewURLMechanism = SportHelper.isNewUrlMechanismEnabled()

        var params = {
            /* runtime */
            containerId: containerId, // html container id
            token: token ? token : '-',
            initialRoute: SportIntegration.getInitialRouting(page),
            // rest: true,
            // log: false,
            parent: [domainforParent],
            defaultLanguage: language,
            // liveScore: 'https://sport.totogaming-digitainpo.builder-tst.com/',
            //customCssUrl: customCssUrl,
            // {Function} Login popup/page opening trigger.
            loginTrigger: function () {
                window.SportLogin && window.SportLogin()
            },
            onBalanceChange: callbacks?.onBalanceChange,

            // {Object} Various events callbacks.
            // events: {
            //     onAppMount: function appMountCallback() {
            //         console.log('app mounted');
            //     }
            // },

            /* servers */
            // serverWs: 'wss://mobilews.sportdigi.com/',   // prod web socket link
            server: launchUrl || `//sport.${domain}/`,      // ajax, sources, etc.
            //externalCSSvariables: cssVariables,
            /* will be modified in the next version */
            // BetCheckerIsBetshop: true,
            // BetHistoryCashbackHide: true,
            // BetHistoryCashoutHide: true,
            zIndex: {
                closed: 950,
                opened: 999,
                fullOpened: 999
            }
        }

        if (isNewURLMechanism) {
            params.urlStructureType = 2;
            params.sportMainPath = `https://${domain}/${language}/sport`;

        }
        if (betslipId) {
            params.betslipBookNumber = betslipId;
        }
        params.betslipCopyLinkUrl = `https://${domain}/${language}/sport/betslip-id/{betslipBookNumber}`;
        if (viewType === SportViewTypeEnum.Asian) {
            params.view = "asian";
        }

        if (enableSiteStylesForSport) {
            const cssVariables = CustomisationHelper.getCustomCssVars();
            params.externalCSSvariables = cssVariables;
        } else if (colorMode) {
            params.projectTheme = ColorModeSportNameEnum[colorMode];
        }

        if ((isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) && !SportIntegration.getInitialRouting(page)) {
            params.initialRoute = SportRoutingHelper.generateRouteObject(page, targetId, isNewURLMechanism);
        }

        //To remove when all partner will be switched to the new url mechanism
        if (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) {
            params.hashRouterDisabled = true;
        }

        if (userSystemRID) {
            params.sportPartner = userSystemRID;
        }
        // if (page === 'BetsHistory') {
        //     params['initialPage'] = 'BetHistory'
        // }

        const iframeParams = { height: 0 }
        if (isDivIntegration) {
            params.hashRouterDisabled = true;
            window.sportMobileApp = await window?.Bootstrapper?.boot(params, { name: 'Mobile' }, iframeParams);
        } else {
            window.sportMobileApp = await window?.Bootstrapper?.bootIframe(params, { name: 'Mobile' }, iframeParams);
            setTimeout(() => {
                let sportFrame = document.querySelector('#sport_mobile_root iframe');
                if (sportFrame) sportFrame.scrolling = 'yes';
                SportIntegration.colculateSportFrameHeight();
            }, 50);
        }


        window?.sportMobileApp?.addEventListener('updateUserBalance', (e) => {
            callbacks?.onBalanceChange(e.data);
        });

        if (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) {
            window?.sportMobileApp?.addEventListener('sportAppEventDispatch', callback);
            //window?.sportMobileApp?.Betslip?.addEventListener('sportAppEventDispatch', callback);
        } else {
            window.sportMobileApp.navigateTo(page)
            if (callbacks?.onNavigateCallback) {
                window.sportMobileApp.addEventListener("navigateToEventPage", function (event) {
                    callbacks.onNavigateCallback(event.data);
                });
                window.sportMobileApp.addEventListener("onNavigate", function (event) {
                    callbacks.onNavigateCallback(event.data);
                });
            }
        }

        if (SportHelper.shouldOpenBetSlip() || SportHelper.shouldOpenMyBets()) {
            window?.sportMobileApp?.addEventListener('page-loaded', (event) => {
                SportHelper.shouldOpenBetSlip() && SportHelper.openBetSlip();
                SportHelper.shouldOpenMyBets() && SportHelper.openMyBets();
            });
        }


    },

    launchWidget: async function (containerId, onNavigateCallback, launchUrl) {
        const language = LanguageService.getSelectedLanguage();
        const domain = Browser.getDomain();
        const domain2 = Browser.getDomain(true, false);
        const cssVariables = CustomisationHelper.getCustomCssVars();
        //const colorMode = CustomisationHelper.getSelectedColorModeName();
        const { userSystemRID } = store.getState().settings;
        var params = {
            /* runtime */
            containerId: containerId, // html container id
            //target: containerId,
            defaultLanguage: language,
            parent: [domain2],
            //customCssUrl: customCssUrl,
            /* servers */
            // serverWs: 'wss://mobilews.sportdigi.com/',   // prod web socket link
            server: launchUrl || `//sport.${domain}/`,      // ajax, sources, etc.
            //externalCSSvariables: cssVariables,
            builderStyles: cssVariables,
            ...userSystemRID ? { sportPartner: userSystemRID } : {},
            betslipCopyLinkUrl: `https://${domain}/${language}/sport/betslip-id/{betslipBookNumber}`
        }

        // if (colorMode) {
        //     params.theme = colorMode;
        //     params.projectTheme = ColorModeSportNames[colorMode];
        // }
        // window.sportApp = await window.Bootstrapper.bootIframe(params, { name: 'TopMatches' }).then(onNavigateCallback);

        window.sportApp = await window.Bootstrapper.bootIframe(params, { name: 'TopMatches' });
        onNavigateCallback(window.sportApp);
        window.sportApp.changeColors(cssVariables);
    },

    destroyMultiBoot() {
        if (window.sportApp) {
            // [window.sportApp?.Betslip, window.sportApp?.Live, window.sportApp?.Prematch, window.sportApp?.Top, window.sportApp?.Jackpot, window.sportApp].forEach(a => a && a.destroy && a.destroy())
            window.sportApp.destroy();
        }
        document.querySelectorAll('.multiboot-widget').forEach(el => el.firstChild && el.removeChild(el.firstChild));
    },

    multiBoot(history, launchUrl, token, config, sportEventsCallback) {
        const that = this;
        setTimeout(() => {
            this.destroyMultiBoot();
            const domain = Browser.getDomain();
            launchUrl = domain.includes("localhost") ? "https://sport.totogaming-digitainpo.builder-tst.com" : launchUrl;

            if (launchUrl && !launchUrl?.startsWith('https://') && !launchUrl?.startsWith('//')) {
                launchUrl = `https://${launchUrl}`;
            }

            if (!document.getElementById('sport-js')) {
                const script = document.createElement("script");
                script.src = `${launchUrl || `https://sport.${domain}`}/js/partner/bootstrapper.min.js`;
                script.id = 'sport-js';
                script['data-hj-allow-iframe'] = ""
                script.onload = function () {
                    that.destroyMultiBoot();
                    SportIntegration.multiBootStart(history, token, launchUrl, config, sportEventsCallback);
                }
                document.body.appendChild(script);
            } else {
                this.destroyMultiBoot();
                SportIntegration.multiBootStart(history, token, launchUrl, config, sportEventsCallback);
            }
        }, 100)
    },

    topMatchesEvetsListeners(topMatches, history) {
        const { partnerId } = store.getState().settings;
        const isNewRoutingModeEnabled = config?.SPORT_NEW_ROUTING?.indexOf(partnerId) >= 0 ? true : false;
        const isNewRoutingEnabledForAllPartners = config?.SPORT_NEW_ROUTING_ENABLED;
        const isNewURLMechanism = SportHelper.isNewUrlMechanismEnabled();

        if (!isNewURLMechanism) {
            topMatches.addEventListener('navigateToEvent', function (messageEvent) {
                const eventData = messageEvent?.data;
                if (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) {
                    const eventName = SportRoutingHelper.makeSeoFriendly(eventData.Name);
                    history.replace(`/sport/event-details/${eventData.champ ? eventData.champ : 0}-${eventData.Id}-${eventData.country ? eventData.country : 0}-${eventData.sport ? eventData.sport : 0}-${eventData.supertip ? eventData.supertip : 0}-${eventData.isLive ? eventData.isLive : 0}-${eventName ? eventName : ''}`);
                } else {
                    history.replace(`/sport/UpcomingDetails/${eventData.Id || eventData.championshipId}`);
                }
            });
            topMatches.addEventListener('navigateToChampionship', function (messageEvent) {
                const eventData = messageEvent.data;
                if (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) {
                    history.replace(`/sport/pre-match/${eventData?.sportName ? eventData.sportName : ''}-${SportRoutingHelper.makeSeoFriendly(eventData.Name)}?${encodeURI(`q={${eventData.sport}:{${eventData.country}:[${eventData.Id}]}}`)}`);
                } else {
                    history.replace(`/sport/Upcoming/${eventData.Id || eventData.championshipId}`);
                }
            });
        }

    },

    multiBootStart(history, token, launchUrl, config = {}, sportEventsCallback) {
        const { isJackpotInactive, isLivePrematchInactive } = config
        const { sportSettings, userSystemRID } = store.getState().settings;
        const { showSportJackpot, showSportPrematchTopMatches, showSportLivePrematchTopMatches,
            showSportPrematchTotalTopMatches, showSportLiveTopMatches, showMultiBetOfTheDay } = sportSettings ? { ...sportSettings, ...config } : {};

        const enableSiteStylesForSport = sportSettings.enableSiteStylesForSport;
        const colorMode = CustomisationHelper.getSelectedColorModeName();
        const domain = Browser.getDomain();
        const domainforParent = Browser.getDomain(true, false);
        const language = LanguageService.getSelectedLanguage()

        const isNewURLMechanism = SportHelper.isNewUrlMechanismEnabled();


        const colorConfigs = {};

        if (enableSiteStylesForSport) {
            const cssVariables = CustomisationHelper.getCustomCssVars();
            colorConfigs.externalCSSvariables = cssVariables;
        } else if (colorMode) {
            colorConfigs.projectTheme = ColorModeSportNameEnum[colorMode];
        }

        const multiBootConfig = {
            server: launchUrl || `https://sport.${domain}`,
            betslipCopyLinkUrl: `https://${domain}/${language}/sport/betslip-id/{betslipBookNumber}`,
            token: token ? token : '-',
            // token: '-',
            //externalCSSvariables: cssVariables,
            ...colorConfigs,
            parent: [domainforParent],

            login: function () {
                window.SportLogin && window.SportLogin()
            },
            // placeBetSuccess: (e) => { balanceChangeCallback(e.data) },
            defaultLanguage: language,
            ...userSystemRID ? { sportPartner: userSystemRID } : {},
            apps: [
                ...showSportPrematchTopMatches ? [{
                    appConfig: { containerId: 'top_matches_sport_widget' },
                    bootConfig: { name: "TopMatches" },
                    ...colorConfigs,
                    method: "bootIframe"
                }] : [],
                ...(showSportLivePrematchTopMatches && !isLivePrematchInactive) ? [{
                    instanceName: 'Top',
                    appConfig: { containerId: 'top_live_prematches_sport_widget', type: 'Top' },
                    bootConfig: { name: "EventWidget" },
                    ...colorConfigs,
                    method: "boot"
                }] : [],
                ...showSportPrematchTotalTopMatches ? [{
                    instanceName: 'Prematch',
                    appConfig: { containerId: 'top_prematches_sport_widget', type: 'Prematch' },
                    bootConfig: { name: "EventWidget" },
                    ...colorConfigs,
                    method: "boot"
                }] : [],
                ...showSportLiveTopMatches ? [{
                    instanceName: 'Live',
                    appConfig: { containerId: 'live_top_matches', type: 'Live' },
                    bootConfig: { name: "EventWidget" },
                    ...colorConfigs,
                    method: "boot"
                }] : [],
                ...showMultiBetOfTheDay ? [{
                    instanceName: 'MultiBetOfTheDay',
                    appConfig: { containerId: 'multibet_of_the_day' },
                    bootConfig: { name: "MultiBetOfTheDay" },
                    ...colorConfigs,
                    method: "boot"
                }] : [],
                ...showSportJackpot && !isJackpotInactive ? [{
                    appConfig: {
                        containerId: 'sport_jackpot_widget',
                        onJackpotItemClick: () => SportIntegration.onJackpotItemClick(history),
                        onMoreBtnClick: () => SportIntegration.onMoreBtnClick(history),
                        variant: "static",
                    },
                    bootConfig: { name: "Jackpot" },
                    method: "boot"
                }] : [],
            ]
        }

        if (isNewURLMechanism) {
            multiBootConfig.urlStructureType = 2;
        }

        if (multiBootConfig.apps[0] && window.Bootstrapper) {
            window.Bootstrapper.multiBoot(multiBootConfig, multiBootConfig.apps[0].instanceName || multiBootConfig.apps[0].bootConfig.name, SportIntegration.cleanUp)
                .then((e) => {
                    SportIntegration.handleMultiBootResponse(e, history, sportEventsCallback);
                })
        }
    },

    onJackpotItemClick(history) {
        const isMobile = Utils.isTablet();
        const rediractionUrl = isMobile ? `/sport/#Jackpot` : `/sport/Home`;
        history.replace(rediractionUrl);
    },

    onMoreBtnClick(history) {
        history.replace(`/sport/#Jackpot`);
    },
    cleanUp: function (e, a, s) {
        // console.log(e, a, s);
    },
    destroy() {
        Object.keys(SportView).map(view => {
            if (window[SportView[view]] && window[SportView[view]].destroy) {
                window[SportView[view]].destroy();
            }
            if (window.SportFrame && window.SportFrame.destroy) {
                window.SportFrame.destroy();
            }
        })
    },
    handleMultiBootResponse: function (app, history, sportEventsCallback) {
        if (app) {
            const cssVariables = CustomisationHelper.getCustomCssVars();
            window.sportApp = app;
            // onNavigateCallback(window.sportApp)
            [app, app.Live, app.Prematch, app.Top].forEach(a => a && SportIntegration.topMatchesEvetsListeners(a, history))

            app.addEventListener('sportAppEventDispatch', sportEventsCallback);

            window.sportApp.changeColors(cssVariables);
            let { uiSettingMode, sportSettings } = store.getState().settings;
            const { enableSiteStylesForSport } = sportSettings;
            if (uiSettingMode && !enableSiteStylesForSport) {
                let storageData = LocalStorageService.get(COLOR_MODE_KEY);
                uiSettingMode = +(storageData?.mode ? storageData.mode : uiSettingMode)
                const colorMode = uiSettingMode ? (uiSettingMode === 2 && 'light' || uiSettingMode === 1 && 'dark') : null;
                if (colorMode) {
                    window.sportApp?.Betslip?.dispatch && window.sportApp?.Betslip?.dispatch('changeTheme', colorMode);
                }
            }
        }
    },

    launchJackpotWidget: async function (containerId, onJackpotItemClick, onMoreBtnClick) {
        const language = LanguageService.getSelectedLanguage();
        const domain = Browser.getDomain();
        const cssVariables = CustomisationHelper.getCustomCssVars();
        const { userSystemRID } = store.getState().settings;
        var params = {
            /* runtime */
            containerId: containerId, // html container id
            //target: containerId,
            defaultLanguage: language,
            onJackpotItemClick,
            parent: [domain],
            onMoreBtnClick,
            //customCssUrl: customCssUrl,
            /* servers */
            // serverWs: 'wss://mobilews.sportdigi.com/',   // prod web socket link
            server: `//sport.${domain}/`,      // ajax, sources, etc.
            externalCSSvariables: cssVariables,
            ...userSystemRID ? { sportPartner: userSystemRID } : {}
            //builderStyles: cssVariables
        }
        // window.sportApp = await window.Bootstrapper.bootIframe(params, { name: 'TopMatches' }).then(onNavigateCallback);

        window.sportApp = await window.Bootstrapper.boot(params, { name: 'Jackpot' });
        // onNavigateCallback(window.sportApp);
        // window.sportApp.changeColors(cssVariables);
    },
    colculateSportFrameHeight: () => {
        const headerHeight = Utils.getHeaderHeight();
        const sportFrame = document.querySelector("#sport_div_iframe iframe");
        const frameHeight = window.innerHeight - headerHeight;
        if (sportFrame) {
            sportFrame.style["min-height"] = `${frameHeight}px`;
            sportFrame.style["max-height"] = `${frameHeight}px`;
        }
        return frameHeight;
    },
    changeColorMode: () => {
        try {
            const colorMode = CustomisationHelper.getSelectedColorModeName();
            const viewType = SportIntegration.retrieveView();
            const { sportApp, esportApp, sportMobileApp, SportFrame } = window;

            const sportWindow = window[viewType] || sportMobileApp || SportFrame;
            if (sportWindow?.starter) {
                sportWindow?.starter?.dispatchEvent('sportAppEventListener', { type: SportEventType.ThemeChange, message: { projectTheme: ColorModeSportNameEnum[colorMode] } });
                sportWindow?.Betslip?.dispatch && window.sportApp?.Betslip?.dispatch('changeTheme', colorMode);
            } else if (sportWindow?.setProjectTheme) {
                try {
                    sportWindow.setProjectTheme(ColorModeSportNameEnum[colorMode]);
                } catch (e) {
                    console.log(e);
                }
            }
            //Change esport color mode of widgets
            if (esportApp?.starter) {
                esportApp?.starter?.dispatchEvent('sportAppEventListener', { type: SportEventType.ThemeChange, message: { projectTheme: ColorModeSportNameEnum[colorMode] } });
                esportApp?.Betslip?.dispatch && esportApp.sportApp?.Betslip?.dispatch('changeTheme', colorMode);
            }

            //Change color mode of widgets
            if (sportApp?.starter) {
                sportApp?.starter?.dispatchEvent('sportAppEventListener', { type: SportEventType.ThemeChange, message: { projectTheme: ColorModeSportNameEnum[colorMode] } });
                //Change color mode of Betslip
                sportApp?.Betslip?.dispatch && sportApp?.Betslip?.dispatch('changeTheme', colorMode);
            }


        } catch (e) {
            console.log(e);
        }
    }
}